import { request } from '../boot/request';

const getProductList = params => {
  params = params || {};
  return request({
    url: '/category',
    method: 'GET',
    params,
  });
};

const getSearchProductList = params => {
  params = params || {};
  return request({
    url: '/productSearch',
    method: 'POST',
    data: params,
  });
};

const getCategories = () => request({
  url: '/categories',
  method: 'GET',
});

const getProdsByCateId = (id) => request({
  url: '/category',
  method: 'GET',
  params: {
    id
  }
});

export {
  getProductList, getSearchProductList, getCategories, getProdsByCateId
};
